// The 529 plans a distribution form may offer: open plans, plus the plan the
// record already sits on even if it is archived. The server refuses new money
// on any other archived plan, so offering one would only lead to a refusal.
// (ZEN-383)
export function planChoices(funds, currentPlanId) {
  return (funds || []).filter((x) => !x.archived || (currentPlanId && x.id === currentPlanId));
}
